import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Text, reExportedColors } from '../../../1elements'
import ConfigAccordionBase from '../ConfigAccordionBase'
import Divider from '@mui/material/Divider'
import EditTabButton from '../../../1elements/Buttons/TextButtons/EditTabButton'
import useFullViewTab from './useFullViewTab'
import styled from '@emotion/styled'

export default function FullViewTab ({
  onEditMode,
  adminSet,
  setAdminSet,
  setMissingDataFieldVisibility,
  missingDataFieldVisibility,
  tabList,
  formik
}) {
  const classes = useStyles()
  const {
    onClickEdit,
    switchGoogleImagePull,
    switchMissingDataFieldVisibility,
    setToDefaultHandler
  } = useFullViewTab({ setAdminSet, setMissingDataFieldVisibility, formik })
  return (
    <ConfigAccordionBase
      className={classes.root}
      label='Full View Tab'
      onEditMode={onEditMode}
      setToDefaultHandler={setToDefaultHandler}
    >
      <Text type='h3' className={classes.color}>
        Tab Layout
      </Text>
      <Divider />
      <div className={classes.innerDiv}>
        <Text type='h3' className={classes.tabNameHeading}>
          Tab Name:
        </Text>
        {tabList.map(
          (tab, i) =>
            tab && (
              <div key={tab.tab_id} className={classes.tabDiv}>
                {onEditMode ? (
                  <input
                    id={`tabList[${i}].custom_name`}
                    name={`tabList[${i}].custom_name`}
                    type='text'
                    onChange={formik.handleChange}
                    value={formik.values.tabList[i].custom_name}
                    placeholder={formik.values.tabList[i].default_name}
                    className={classes.input}
                  />
                ) : (
                  <Text type='h3'>{tab.custom_name}</Text>
                )}

                {onEditMode && (
                  <Text type='p' className={classes.error}>
                    {formik.errors.tabList &&
                      formik.errors.tabList[i] &&
                      formik.errors.tabList[i].custom_name}
                  </Text>
                )}
                <EditTabButton onClick={() => onClickEdit(tab.sys_name)} />
              </div>
            )
        )}
      </div>
      <Text type='h3' className={classes.color}>
        Google Image Pull
      </Text>
      <Divider />

      <LgContainer>
        <SmContainer>
          <WordContainer>
            Ten (10) images are randomly pulled from Google to the 
            Location Gallery when the toggle icon is enabled. Please disable 
            this feature if you do not want to pull images from Google.
          </WordContainer>
        </SmContainer>

        <SmContainer>
          <Container>
            {onEditMode ? (
              <>
                <Enable
                  color={
                    adminSet ? reExportedColors.RED : reExportedColors.TEXT_BOLD
                  }
                >
                  Enable
                </Enable>
                <SwitchContainer onClick={switchGoogleImagePull}>
                  <Circle
                    left={adminSet ? '-11px' : '11px'}
                    circleColor={
                      adminSet
                        ? reExportedColors.RED
                        : reExportedColors.MEDIUM_GREY
                    }
                  />
                </SwitchContainer>
                <Disable color={!adminSet ? 'red' : reExportedColors.TEXT_BOLD}>
                  Disable
                </Disable>
              </>
            ) : (
              <>
                <Enable color={adminSet ? 'red' : reExportedColors.TEXT_BOLD}>
                  Enable
                </Enable>
                <SwitchContainer>
                  <Circle
                    left={adminSet ? '-11px' : '11px'}
                    circleColor={
                      adminSet
                        ? reExportedColors.RED
                        : reExportedColors.MEDIUM_GREY
                    }
                  />
                </SwitchContainer>
                <Disable color={!adminSet ? 'red' : reExportedColors.TEXT_BOLD}>
                  Disable
                </Disable>
              </>
            )}
          </Container>
        </SmContainer>
      </LgContainer>

      <Text type='h3' className={classes.color}>
        Missing Data Field Visibility
      </Text>
      <Divider />

      <LgContainer>
        <SmContainer>
          <WordContainer>
            When this feature is enabled, fields with missing data will be hidden. 
            Disable this feature if you wish to see fields with missing data.
          </WordContainer>
        </SmContainer>

        <SmContainer>
          <Container>
            {onEditMode ? (
              <>
                <Enable
                  color={
                    missingDataFieldVisibility
                      ? reExportedColors.RED
                      : reExportedColors.TEXT_BOLD
                  }
                >
                  Enable
                </Enable>
                <SwitchContainer onClick={switchMissingDataFieldVisibility}>
                  <Circle
                    left={missingDataFieldVisibility ? '-11px' : '11px'}
                    circleColor={
                      missingDataFieldVisibility
                        ? reExportedColors.RED
                        : reExportedColors.MEDIUM_GREY
                    }
                  />
                </SwitchContainer>
                <Disable
                  color={
                    !missingDataFieldVisibility
                      ? reExportedColors.RED
                      : reExportedColors.TEXT_BOLD
                  }
                >
                  Disable
                </Disable>
              </>
            ) : (
              <>
                <Enable
                  color={
                    missingDataFieldVisibility
                      ? reExportedColors.RED
                      : reExportedColors.TEXT_BOLD
                  }
                >
                  Enable
                </Enable>
                <SwitchContainer>
                  <Circle
                    left={missingDataFieldVisibility ? '-11px' : '11px'}
                    circleColor={
                      missingDataFieldVisibility
                        ? reExportedColors.RED
                        : reExportedColors.MEDIUM_GREY
                    }
                  />
                </SwitchContainer>
                <Disable
                  color={
                    !missingDataFieldVisibility
                      ? reExportedColors.RED
                      : reExportedColors.TEXT_BOLD
                  }
                >
                  Disable
                </Disable>
              </>
            )}
          </Container>
        </SmContainer>
      </LgContainer>
    </ConfigAccordionBase>
  )
}

/// /// HARDCODED TO USE CONSTS - to be Assigned a palette color -- inside the tags above

const useStyles = makeStyles(theme => ({
  root: {
    padding: '30px 20px'
  },
  innerDiv: {
    width: '70%',
    margin: '20px auto',
    display: 'flex',
    '&>div': {
      margin: '0 40px'
    }
  },
  input: {
    border: '1.5px solid #9A9A9A',
    borderRadius: 5,
    height: 30,
    width: 90,
    marginBottom: 5
  },
  tabDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  tabNameHeading: {
    color: theme.palette.primary.main,
    marginTop: 5
  },
  error: {
    color: reExportedColors.RED,
    display: 'inline-block',
    width: 110,
    fontSize: 14,
    lineHeight: 1,
    marginBottom: 5
  }
}))

const LgContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  justifySelf: 'center',
  width: '100%',
  height: '100%',
  padding: 50
})

const WordContainer = styled.div({
  display: 'flex',
  width: '80%',
  height: '100%'
})

const SmContainer = styled.div({
  display: 'flex',
  width: '80%',
  height: '100%'
})

const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center'
})

const SwitchContainer = styled.div({
  width: '50px',
  height: '25px',
  borderRadius: '50px',
  backgroundColor: `${reExportedColors.WHITE}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 'black 1px solid'
})

const Enable = styled.p(
  {
    fontSize: '14px',
    margin: 0,
    paddingRight: 5
  },
  props => ({
    color: props.color
  })
)

const Disable = styled.p(
  {
    fontSize: '14px',
    margin: 0,
    paddingLeft: 5
  },
  props => ({
    color: props.disableColor
  })
)

const Circle = styled.div(
  {
    position: 'relative',
    width: 20,
    height: 20,
    borderRadius: '50%',
    transition: 'left 0.3s'
  },
  props => ({
    left: props.left,
    backgroundColor: props.circleColor
  })
)
